import React, { useEffect, useState } from 'react'
import Address from './SubTab/Address'
import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
import { useFormik } from 'formik';
import axios from 'axios';
import { adminMainUrl } from '../../../../../Config';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import Beatloader from '../../../../../Common/Loaders/Beatloader';

const ServiceTab = ({ token, user_id, b64id, loadingJobOrderEmployeeList, JobOrderEmployeeListError, JobOrderEmployeeList, loadingJobOrderServiceDetail, JobOrderServiceDetailError, JobOrderServiceDetail, refreshService, JobOrderDetail }) => {
    const dispatch = useDispatch();
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [employeeLoading, setEmployeeLoading] = useState(false);



    let [company_name, setComapny_name] = useState("Flexichain Ltd.");

    useEffect(() => {
        if (JobOrderDetail) {
            if (JobOrderDetail.company_name) {
                // console.log("jjffdjdsfjfsdj",JobOrderDetail.company_name);
                setComapny_name(JobOrderDetail.company_name);
            } else {
                setComapny_name("Flexichain Ltd.");
            }
        } else {
            setComapny_name("Flexichain Ltd.");
        }
    }, [JobOrderDetail]);

    useEffect(() => {
        if (loadingJobOrderEmployeeList) {
            setEmployeeLoading(true);
        } else {
            setEmployeeLoading(false);
        }

        if (JobOrderEmployeeList) {
            let arr = [];
            JobOrderEmployeeList.map(val => { arr.push({ value: val.user_id, label: val.name }) });
            setEmployeeOptions(arr);
        }

    }, [loadingJobOrderEmployeeList, JobOrderEmployeeList])


    const initialValues = {
        job_order_id: "",
        is_freight: false,
        is_customs: false,
        is_transport: false,
        is_general_job: false,
        freight_service_type: "Self",
        freight_service_company_name: company_name,
        freight_location: "",
        freight_responsibility: "User",
        freight_team_user_id: 0,
        customs_service_type: "Self",
        customs_service_company_name: company_name,
        customs_location: "",
        customs_responsibility: "User",
        customs_team_user_id: 0,
        transport_service_type: "Self",
        transport_service_company_name: company_name,
        transport_location: "",
        transport_responsibility: "User",
        transport_team_user_id: 0,
        general_job_service_type: "Self",
        general_job_service_company_name: company_name,
        job_owner_id: 0
    };

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                values.job_order_id = atob(b64id);
                axios.post(`${adminMainUrl}/api/jobOrder/service/add-update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            // refresh();
                            refreshService();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    useEffect(() => {
        if (loadingJobOrderServiceDetail) {
            setShowLoader(true)
        } else {
            setShowLoader(false)
        }

        if (JobOrderServiceDetail) {
            // console.log(JobOrderServiceDetail);
            formik.setFieldValue("is_freight", JobOrderServiceDetail?.is_freight);
            formik.setFieldValue("is_customs", JobOrderServiceDetail?.is_customs);
            formik.setFieldValue("is_transport", JobOrderServiceDetail?.is_transport);
            formik.setFieldValue("is_general_job", JobOrderServiceDetail?.is_general_job);
            formik.setFieldValue("freight_service_type", JobOrderServiceDetail?.freight_service_type);
            formik.setFieldValue("freight_service_company_name", JobOrderServiceDetail?.freight_service_company_name);
            formik.setFieldValue("freight_location", JobOrderServiceDetail?.freight_location);
            formik.setFieldValue("freight_responsibility", JobOrderServiceDetail?.freight_responsibility);
            formik.setFieldValue("freight_team_user_id", Number(JobOrderServiceDetail?.freight_team_user_id));
            formik.setFieldValue("customs_service_type", JobOrderServiceDetail?.customs_service_type);
            formik.setFieldValue("customs_service_company_name", JobOrderServiceDetail?.customs_service_company_name);
            formik.setFieldValue("customs_location", JobOrderServiceDetail?.customs_location);
            formik.setFieldValue("customs_responsibility", JobOrderServiceDetail?.customs_responsibility);
            formik.setFieldValue("customs_team_user_id", Number(JobOrderServiceDetail?.customs_team_user_id));
            formik.setFieldValue("transport_service_type", JobOrderServiceDetail?.transport_service_type);
            formik.setFieldValue("transport_service_company_name", JobOrderServiceDetail?.transport_service_company_name);
            formik.setFieldValue("transport_location", JobOrderServiceDetail?.transport_location);
            formik.setFieldValue("transport_responsibility", JobOrderServiceDetail?.transport_responsibility);
            formik.setFieldValue("transport_team_user_id", Number(JobOrderServiceDetail?.transport_team_user_id));
            formik.setFieldValue("general_job_service_type", JobOrderServiceDetail?.general_job_service_type);
            formik.setFieldValue("general_job_service_company_name", JobOrderServiceDetail?.general_job_service_company_name);
        }

        // ─── Set job_owner_id from JobOrderDetail ───
        if (JobOrderDetail) {
            formik.setFieldValue("job_owner_id", JobOrderDetail?.job_owner_id || 0);
        }
    }, [loadingJobOrderServiceDetail, JobOrderServiceDetailError, JobOrderServiceDetail, employeeOptions, JobOrderDetail])

    // ─── Keep team_user_id in sync with job_owner_id when service is enabled ───
    useEffect(() => {
        const jobOwnerId = formik.values.job_owner_id || 0;
        // For freight
        if (formik.values.is_freight) {
            formik.setFieldValue("freight_team_user_id", jobOwnerId);
        } else {
            formik.setFieldValue("freight_team_user_id", 0);
        }
        // For customs
        if (formik.values.is_customs) {
            formik.setFieldValue("customs_team_user_id", jobOwnerId);
        } else {
            formik.setFieldValue("customs_team_user_id", 0);
        }
        // For transport
        if (formik.values.is_transport) {
            formik.setFieldValue("transport_team_user_id", jobOwnerId);
        } else {
            formik.setFieldValue("transport_team_user_id", 0);
        }
    }, [
        formik.values.is_freight,
        formik.values.is_customs,
        formik.values.is_transport,
        formik.values.job_owner_id
    ]);

    //manage disability and options
    const [disableFreightFields, setDisableFreightFiels] = useState(false);
    useEffect(() => {
        if (formik.values.is_freight) {
            setDisableFreightFiels(false);
        } else {
            setDisableFreightFiels(true);
        }
    }, [formik.values.is_freight]);

    const [freightCompanyOptions, setFreightCompanyOptions] = useState([]);
    useEffect(() => {
        if (formik.values.freight_service_type == "Self") {
            let arr = [{
                value: company_name,
                label: company_name
            }];
            setFreightCompanyOptions(arr);
            formik.setFieldValue("freight_service_company_name", company_name)
        } else {
            setFreightCompanyOptions([]);
            formik.setFieldValue("freight_service_company_name", "")
            formik.setFieldValue("freight_team_user_id", "")
        }
    }, [formik.values.freight_service_type,company_name])


    let [freightUserOptions, setFreightUserOptions] = useState(employeeOptions);
    useEffect(() => {
        if (formik.values.freight_responsibility == "User") {
            setFreightUserOptions(employeeOptions);
        } else {
            setFreightUserOptions([]);
        }
    }, [formik.values.freight_responsibility, employeeOptions])




    const [disableCustomsFields, setDisableCustomsFiels] = useState(false);
    useEffect(() => {
        if (formik.values.is_customs) {
            setDisableCustomsFiels(false);
        } else {
            setDisableCustomsFiels(true);
        }
    }, [formik.values.is_customs]);
    const [customsCompanyOptions, setCustomsCompanyOptions] = useState([]);
    useEffect(() => {
        if (formik.values.customs_service_type == "Self") {
            let arr = [{
                value: company_name,
                label: company_name
            }];
            setCustomsCompanyOptions(arr);
            formik.setFieldValue("customs_service_company_name", company_name)
            formik.setFieldValue("customs_location", "Delhi")
        } else {
            setCustomsCompanyOptions([]);
            formik.setFieldValue("customs_service_company_name", "")
            formik.setFieldValue("customs_location", "")
            formik.setFieldValue("customs_team_user_id", "")
        }
    }, [formik.values.customs_service_type,company_name]);

    let [customsUserOptions, setCustomsUserOptions] = useState(employeeOptions);
    useEffect(() => {
        if (formik.values.customs_responsibility == "User") {
            setCustomsUserOptions(employeeOptions);
        } else {
            setCustomsUserOptions([]);
        }
    }, [formik.values.customs_responsibility, employeeOptions])




    const [disableTransportFields, setDisableTransportFiels] = useState(false);
    useEffect(() => {
        if (formik.values.is_transport) {
            setDisableTransportFiels(false);
        } else {
            setDisableTransportFiels(true);
        }
    }, [formik.values.is_transport]);
    const [transportCompanyOptions, setTransportCompanyOptions] = useState([]);
    useEffect(() => {
        if (formik.values.transport_service_type == "Self") {
            let arr = [{
                value: company_name,
                label: company_name
            }];
            setTransportCompanyOptions(arr);
            formik.setFieldValue("transport_service_company_name", company_name)
            formik.setFieldValue("transport_location", "Delhi")

        } else {
            setTransportCompanyOptions([]);
            formik.setFieldValue("transport_service_company_name", "")
            formik.setFieldValue("transport_team_user_id", "")
            formik.setFieldValue("transport_location", "")

        }
    }, [formik.values.transport_service_type,company_name]);

    let [transportUserOptions, setTransportUserOptions] = useState(employeeOptions);
    useEffect(() => {
        if (formik.values.transport_responsibility == "User") {
            setTransportUserOptions(employeeOptions);
        } else {
            setTransportUserOptions([]);
        }
    }, [formik.values.transport_responsibility, employeeOptions])




    const [disableGeneralJobFields, setDisablGeneralJobFiels] = useState(false);
    useEffect(() => {
        if (formik.values.is_general_job) {
            setDisablGeneralJobFiels(false);
        } else {
            setDisablGeneralJobFiels(true);
        }
    }, [formik.values.is_general_job]);
    const [generalJobCompanyOptions, setGeneralJobCompanyOptions] = useState([]);
    useEffect(() => {
        if (formik.values.general_job_service_type == "Self") {
            let arr = [{
                value:company_name,
                label:company_name
            }];
            setGeneralJobCompanyOptions(arr);
            formik.setFieldValue("general_job_service_company_name",company_name)
            formik.setFieldValue("freight_location", "Delhi")
        } else {
            setGeneralJobCompanyOptions([]);
            formik.setFieldValue("general_job_service_company_name", "")
            formik.setFieldValue("freight_location", "")
        }
    }, [formik.values.general_job_service_type,company_name]);


    let [disableFreightCheckbox, setDisableFreightCheckbox] = useState(false);
    let [disableCustomCheckbox, setDisableCustomCheckbox] = useState(false);
    useEffect(() => {
        if (JobOrderDetail && JobOrderDetail.quotation_id && JobOrderDetail.quotation_service_type) {
            if (JobOrderDetail.quotation_service_type == "Freight Forwarding") {
                formik.setFieldValue("is_freight", true);
                setDisableFreightCheckbox(true);
            } else if (JobOrderDetail.quotation_service_type == "Custom Clearance") {
                formik.setFieldValue("is_customs", true);
                setDisableCustomCheckbox(true);
            } else if (JobOrderDetail.quotation_service_type == "Both") {
                formik.setFieldValue("is_freight", true);
                formik.setFieldValue("is_customs", true);
                setDisableFreightCheckbox(true);
                setDisableCustomCheckbox(true);
            }
        } else {
            formik.setFieldValue("is_freight", false);
            formik.setFieldValue("is_customs", false);
            setDisableFreightCheckbox(false);
            setDisableCustomCheckbox(false);
        }
    }, [JobOrderDetail])



    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <>
                        <div className="row border-bottom-2 pb-3">
                            <div className="col-md-12">
                                <div className="card px-3 py-2">
                                    <div className="row">
                                        <form onSubmit={formik.handleSubmit}>
                                            <table className="table table-striped table-sm">
                                                <thead>
                                                    <tr>
                                                        <th scope="col"></th>
                                                        <th scope="col"></th>
                                                        <th scope="col"></th>
                                                        <th scope="col">Location</th>
                                                        <th scope="col">Responsibility</th>
                                                        <th scope="col">Team/User</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {/* freight */}
                                                    <tr>
                                                        <th scope="row">
                                                            <input
                                                                type="checkbox"
                                                                className=''
                                                                id="is_freight"
                                                                name="is_freight"
                                                                onChange={(e) => {
                                                                    formik.setFieldValue("is_freight", e.target.checked);
                                                                }}
                                                                checked={formik.values.is_freight}
                                                                disabled={disableFreightCheckbox}
                                                                title={disableCustomCheckbox && "This field is disabled because service type contains Freight"}
                                                            />
                                                            <label className='mx-1' htmlFor="Freight">Freight</label>
                                                        </th>
                                                        <td>
                                                            <select className="form-control form-control-sm"
                                                                name="freight_service_type"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.freight_service_type}
                                                                disabled={disableFreightFields}
                                                            >
                                                                <option value="">-</option>
                                                                <option value="Self">Self</option>
                                                                <option value="Group Company">Group Company</option>
                                                                <option value="Other">Other</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <select className="form-control form-control-sm"
                                                                name="freight_service_company_name"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.freight_service_company_name}
                                                                disabled={disableFreightFields}
                                                            >
                                                                <option value="">-</option>
                                                                {freightCompanyOptions.map((val, index) => {
                                                                    return <option value={val.value} key={index + 1}>{val.label}</option>
                                                                })}
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <select
                                                                className="form-control form-control-sm"
                                                                name="freight_location"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.freight_location}
                                                                disabled={disableFreightFields}
                                                            >
                                                                <option value="">-</option>
                                                                <option value="Delhi">Delhi</option>
                                                                {/* <option value="Kolkata">Kolkata</option>
                                                                <option value="Mumbai">Mumbai</option>
                                                                <option value="Pune">Pune</option> */}
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <select className="form-control form-control-sm"
                                                                name="freight_responsibility"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.freight_responsibility}
                                                                disabled={disableFreightFields}
                                                            >
                                                                <option value="">-</option>
                                                                <option value="User">User</option>
                                                                <option value="Team">Team</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            {/* ─── READ-ONLY INPUT with border ─── */}
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={JobOrderDetail?.user_info?.name || '-'}
                                                                readOnly
                                                            />
                                                        </td>
                                                    </tr>
                                                    {/* Customs */}
                                                    <tr>
                                                        <th scope="row">
                                                            <input
                                                                type="checkbox"
                                                                className=''
                                                                id="is_customs"
                                                                name="is_customs"
                                                                onChange={(e) => {
                                                                    formik.setFieldValue("is_customs", e.target.checked);
                                                                }}
                                                                checked={formik.values.is_customs}
                                                                disabled={disableCustomCheckbox}
                                                                title={disableCustomCheckbox && "This field is disabled because service type contains Custom."}
                                                            />
                                                            <label className='mx-1' htmlFor="Customs">Customs</label>
                                                        </th>
                                                        <td>
                                                            <select className="form-control form-control-sm"
                                                                name="customs_service_type"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.customs_service_type}
                                                                disabled={disableCustomsFields}
                                                            >
                                                                <option value="">-</option>
                                                                <option value="Self">Self</option>
                                                                <option value="Group Company">Group Company</option>
                                                                <option value="Other">Other</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <select className="form-control form-control-sm"
                                                                name="customs_service_company_name"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.customs_service_company_name}
                                                                disabled={disableCustomsFields}
                                                            >
                                                                <option value="">-</option>
                                                                {customsCompanyOptions.map((val, index) => {
                                                                    return <option value={val.value} key={index + 1}>{val.label}</option>
                                                                })}
                                                                {/* <option value="Flexichain Ltd.">Flexichain Ltd.</option> */}
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <select
                                                                className="form-control form-control-sm"
                                                                name="customs_location"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.customs_location}
                                                                disabled={disableCustomsFields}
                                                            >
                                                                <option value="">-</option>
                                                                <option value="Delhi">Delhi</option>
                                                                {/* <option value="Kolkata">Kolkata</option>
                                                                <option value="Mumbai">Mumbai</option>
                                                                <option value="Pune">Pune</option> */}
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <select className="form-control form-control-sm"
                                                                name="customs_responsibility"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.customs_responsibility}
                                                                disabled={disableCustomsFields}
                                                            >
                                                                <option value="">-</option>
                                                                <option value="User">User</option>
                                                                <option value="Team">Team</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            {/* ─── READ-ONLY INPUT with border ─── */}
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={JobOrderDetail?.user_info?.name || '-'}
                                                                readOnly
                                                            />
                                                        </td>
                                                    </tr>
                                                    {/* Transport */}
                                                    <tr>
                                                        <th scope="row">
                                                            <input
                                                                type="checkbox"
                                                                className=''
                                                                id="is_transport"
                                                                name="is_transport"
                                                                onChange={(e) => {
                                                                    formik.setFieldValue("is_transport", e.target.checked);
                                                                }}
                                                                checked={formik.values.is_transport}
                                                            />
                                                            <label className='mx-1' htmlFor="Transport">Transport</label>
                                                        </th>
                                                        <td>
                                                            <select className="form-control form-control-sm"
                                                                name="transport_service_type"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.transport_service_type}
                                                                disabled={disableTransportFields}
                                                            >
                                                                <option value="">-</option>
                                                                <option value="Self">Self</option>
                                                                <option value="Group Company">Group Company</option>
                                                                <option value="Other">Other</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <select className="form-control form-control-sm"
                                                                name="transport_service_company_name"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.transport_service_company_name}
                                                                disabled={disableTransportFields}
                                                            >
                                                                <option value="">-</option>
                                                                {transportCompanyOptions.map((val, index) => {
                                                                    return <option value={val.value} key={index + 1}>{val.label}</option>
                                                                })}
                                                                {/* <option value="Flexichain Ltd.">Flexichain Ltd.</option> */}
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <select
                                                                className="form-control form-control-sm"
                                                                name="transport_location"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.transport_location}
                                                                disabled={disableTransportFields}
                                                            >
                                                                <option value="">-</option>
                                                                <option value="Delhi">Delhi</option>
                                                                {/* <option value="Kolkata">Kolkata</option>
                                                                <option value="Mumbai">Mumbai</option>
                                                                <option value="Pune">Pune</option> */}
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <select className="form-control form-control-sm"
                                                                name="transport_responsibility"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.transport_responsibility}
                                                                disabled={disableTransportFields}
                                                            >
                                                                <option value="">-</option>
                                                                <option value="User">User</option>
                                                                <option value="Team">Team</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            {/* ─── READ-ONLY INPUT with border ─── */}
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={JobOrderDetail?.user_info?.name || '-'}
                                                                readOnly
                                                            />
                                                        </td>
                                                    </tr>
                                                    {/* General Job */}
                                                    <tr>
                                                        <th scope="row">
                                                            <input
                                                                type="checkbox"
                                                                className=''
                                                                id="is_general_job"
                                                                name="is_general_job"
                                                                onChange={(e) => {
                                                                    formik.setFieldValue("is_general_job", e.target.checked);
                                                                }}
                                                                checked={formik.values.is_general_job}
                                                            />
                                                            <label className='mx-1' htmlFor="General Job">General Job</label>
                                                        </th>
                                                        <td>
                                                            <select className="form-control form-control-sm"
                                                                name="general_job_service_type"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.general_job_service_type}
                                                                disabled={disableGeneralJobFields}
                                                            >
                                                                <option value="">-</option>
                                                                <option value="Self">Self</option>
                                                                <option value="Group Company">Group Company</option>
                                                                <option value="Other">Other</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <select className="form-control form-control-sm"
                                                                name="general_job_service_company_name"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.general_job_service_company_name}
                                                                disabled={disableGeneralJobFields}
                                                            >
                                                                <option value="">-</option>
                                                                {generalJobCompanyOptions.map((val, index) => {
                                                                    return <option value={val.value} key={index + 1}>{val.label}</option>
                                                                })}
                                                                {/* <option value="Flexichain Ltd.">Flexichain Ltd.</option> */}
                                                            </select>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                            <div className="row d-flex justify-content-end">
                                                <div className="col-md-6 d-flex justify-content-end">
                                                    <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                                        {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }
        </>

    )
}

export default ServiceTab